import { render } from "./SubjectSelection.vue?vue&type=template&id=6627f84a"
import script from "./SubjectSelection.vue?vue&type=script&lang=js"
export * from "./SubjectSelection.vue?vue&type=script&lang=js"

import "./SubjectSelection.vue?vue&type=style&index=0&id=6627f84a&lang=css"

import exportComponent from "/var/www/html/doc_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__